export default __webpack_public_path__ + "static/media/iq.6a255d83.svg";